/** Ключ в `sessionStorage`: закреплено ли боковое меню. */
export const SHELL_SIDEBAR_PINNED_STORAGE_KEY = 'smart-customs-declaration.shell.sidebar.pinned';

export function readStoredSidebarPinned(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(SHELL_SIDEBAR_PINNED_STORAGE_KEY) === '1';
}

export function writeStoredSidebarPinned(pinned: boolean): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  if (pinned) {
    sessionStorage.setItem(SHELL_SIDEBAR_PINNED_STORAGE_KEY, '1');
  } else {
    sessionStorage.removeItem(SHELL_SIDEBAR_PINNED_STORAGE_KEY);
  }
}

/** Сброс при выходе из приложения, чтобы следующий вход не наследовал состояние оболочки. */
export function clearStoredSidebarPinned(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.removeItem(SHELL_SIDEBAR_PINNED_STORAGE_KEY);
}
